<template lang="pug">
  .waom-signature
    input(ref="input" type="hidden" name="signature" v-model="sigVal" v-show="canSignature")
    img(ref="img" id="imageBox" v-bind:src="sigVal" class="boxed imageBox")
</template>
<script>
  import moment from "moment"
  import WacomSignatureManager from '@/assets/js/signature/WacomSignatureManager';
  export default {
    name: 'WacomSignature',
    props: {
      value: {
        type: String,
        default: ''
      },
      imgWidth: {
        type: Number,
        default: 200
      },
      imgHeight: {
        type: Number,
        default: 100
      }
    },
    data() {
      return {
        signature: null,
        sigVal: '',
        canSignature: false
      }
    },
    created() {
      this.$nextTick(() => {
          try {
              this.signature = new WacomSignatureManager({width: this.$props.imgWidth, height: this.$props.imgHeight});
              this.signature.OnLoad(() => {}, (e) => {
                this.$store.commit('showSnackbar', [(e ? e : 'Проверьте подключение планшета для подиси'), 6000, 'error']);
                this.$emit('capture-cancel');
              });
              //if (this.$props.imgWidth) this.$refs.img.style.width = this.$props.imgWidth + 'px';
              //if (this.$props.imgHeight) this.$refs.img.style.height = this.$props.imgHeight + 'px';
              this.$on('capture', this.capture);
              this.canSignature = true;
          } catch (e) {
           this.$store.commit('showSnackbar', ['Планшет для подписи не подключен', 6000, 'error']);
           this.canSignature = false;
          }
          if (this.$props.value !== this.sigVal) this.sigVal = this.$props.value;
      });
    },
    watch: {
      '$props.value'(val) {
        if (val !== this.sigVal) this.sigVal = val;
      },
      'sigVal'(val) {
        if (this.$props.value !== val) {
          this.$emit('input', val);
          this.$emit('change', val);
        }
      }
    },
    computed: {},
    methods: {
      capture() {
        this.signature.Capture(this.onCapture, this.onError);
      },
      onError(error) {
        this.$store.commit('showSnackbar', [error, 6000, 'error']);
      },
      onCapture(sig) {
        this.$nextTick(() => {
          if (sig) {
            this.sigVal = sig;
            this.$emit('capture-complete', sig);
          } else {
            this.$store.commit('showSnackbar', ['Ошибка подписи', 6000, 'error']);
            this.$emit('capture-cancel');
          }
        });
      }
    }
  }
</script>
<style scoped lang="sass">
  #imageBox
    max-width: 200px
    max-height: 200px
</style>



// WEBPACK FOOTER //
// WacomSignature.vue?d5cec96e